var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"text-img",attrs:{"src":require("@/assets/images/header-img.png")}})])
}]

export { render, staticRenderFns }